import React from 'react';
import exact from 'prop-types-exact';
import { Glyphicon } from 'react-bootstrap';


import { lookupStatusPropType } from '../../../propTypes';


const propTypes = exact({
  lookupStatus: lookupStatusPropType.isRequired,
});


const lookupStatusIcons = {
  matched: {
    color: 'green',
    glyph: 'ok-sign',
  },
  unmatched: {
    color: 'purple',
    glyph: 'exclamation-sign',
  },
  reference: {
    color: 'black',
    glyph: 'book',
  },
};


const LookupStatusIcon = (props) => {
  const { lookupStatus } = props;
  const { color, glyph } = lookupStatusIcons[lookupStatus];
  const style = {
    color,
  };

  return (
    <Glyphicon style={style} glyph={glyph} />
  );
};


LookupStatusIcon.propTypes = propTypes;


export default LookupStatusIcon;
